export default "__VITE_ASSET__fzw1IOSt__"